import React, { useState } from "react";
import InstrumentChart from "./instrument-chart/InstrumentChart";
import { formatAmount, formatDate } from "../../../../../../util/Helpers"
import EarningChart from "./EarningChart";
import AnalystChart from "./AnalystChart";
import NewsList from "./NewsList";
import SimpleTable from "my-simple-react-table";
import { Button } from "react-bootstrap";
import { Permission } from "../../../../../Common/layout/Permission";
import { Permissions, PermissionType } from "../../../../../../util/Permissions";
import { EditInstrumentModal } from "./modals/EditInstrumentModal";

const InstrumentDetails = ({ instrument }) => {

    const [showInstrumentModal, setShowInstrumentModal] = useState(false)

    return <>
        <div className="container">
            <div className="d-flex mb-4 justify-content-end">
                <Permission pemission={Permissions.INSTRUMENTS} permissionType={PermissionType.UPDATE}>
                    <Button
                        variant="dark"
                        onClick={() => setShowInstrumentModal(true)}
                    >
                        Edit Instrument
                    </Button>
                </Permission>
            </div>
            <div className="row">
                <div className="col-lg-9">
                    <InstrumentChart quote={instrument?.quote} history={instrument.history} currency={instrument.currency} />
                </div>
                <div className="col-lg-3 mt-4 mt-lg-0">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title py-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Fundamentals</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-0">
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Open</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.open)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Low</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.low)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">High</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.high)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Prev Close</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.previousClose)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Vol (24hrs)</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {instrument?.quote?.totalDailyVolume?.toLocaleString()}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">52 Week High </span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.week52High)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">52 Week Low</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {formatAmount(instrument.currency, instrument?.quote?.week52Low)}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Market Cap</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {instrument?.quote?.marketCap?.toLocaleString()}</span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Dividend</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">Type</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> {instrument?.type}</span>
                                </div>

                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-lg-3">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title py-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Key Statistics</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-0">
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">P/E RATIO</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">PB. RATIO</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">EPS</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">REVENUE</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">NET INCOME</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                                {/* <!--begin::Field--> */}
                                <div className="d-flex flex-column flex-grow-1 mt-0 mb-2 pr-3">
                                    <span className="text-dark-75 font-weight-bolder font-size-lg text-hover-primary">PROFIT</span>
                                    <span className="text-muted font-weight-bold font-size-sm my-1"> - </span>
                                </div>
                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
                <div className="col-lg mt-4 mt-lg-0">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title py-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Earnings Report</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0 px-lg-2">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-4">
                                <EarningChart />
                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
                <div className="col-lg mt-4 mt-lg-0">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title py-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Analyst Rating</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0 px-lg-2">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-4">
                                <AnalystChart />
                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-lg-5">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title py-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">News</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0 pr-4">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-0 overflow-auto px-5" style={{ height: "400px" }}>
                                <NewsList news={instrument.news} />
                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
                <div className="col-lg mt-4 mt-lg-0">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title pt-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Holders</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            {/* <!--begin::Item--> */}
                            <div className="d-flex flex-column mt-0 px-4 overflow-auto" style={{ height: "400px" }}>
                                <SimpleTable
                                    searchBox={false}
                                    rowPerPage={5}
                                    columns={[
                                        { title: "HOLDERS", key: "holders" },
                                        { title: "SHARES", key: "shares" },
                                        { title: "DATE", format: row => formatDate(row.date) }
                                    ]}
                                />
                            </div>
                            {/* <!--end::Item--> */}

                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col">
                    <div className="card card-custom gutter-b  card-stretch">
                        <div className="card-header h-auto border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title pt-5">
                                <h3 className="card-label">
                                    <span className="d-block text-muted font-weight-bolder">Asset Description</span>
                                </h3>
                            </div>
                            {/* <!--end::Title--> */}
                        </div>
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">

                            <h4> <img src={instrument?.imageUrl} className="mr-3" height="30px" width="30px" alt={instrument.name.substr(0, 1)} /> {instrument.name}</h4>
                            <p>{instrument.description}</p>
                            <div className="row mt-5">
                                <div className="col-lg">
                                    <h6 className="text-muted small">ADDRESS</h6>
                                    <p>{instrument?.meta?.address}</p>
                                </div>
                                <div className="col-lg">
                                    <h6 className="text-muted small">PHONE</h6>
                                    <p>{instrument?.meta?.phone}</p>
                                </div>
                                <div className="col-lg">
                                    <h6 className="text-muted small">WEBSITE</h6>
                                    <p>
                                        <a
                                            href={instrument?.url ?? ""}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {instrument?.url}
                                        </a>
                                    </p>
                                </div>
                            </div>


                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                </div>
            </div>
        </div>

        <EditInstrumentModal
            show={showInstrumentModal}
            onHide={() => setShowInstrumentModal(false)}
            details={instrument}
        />
    </>
}

export default InstrumentDetails;